import React, { useState } from 'react';
import { ActionButton, Flex, View } from '@adobe/react-spectrum';
import { getProjectState } from 'app/stores/project';
import { ProjectActions } from 'app/stores/project/actions';
import { useAppDispatch } from 'app/stores/store';
import { ColorsGrid } from 'app/views/components/editor/pickers/ColorsGrid';
import { getMarkerSizeRange, SizeIcon, } from 'app/views/components/editor/pickers/SizeIcon';
import { SizesGrid } from 'app/views/components/editor/pickers/SizesGrid';
import { useConnect } from 'app/views/hooks/useConnect';
import { call } from 'app/utils/function';
const SizeColorGrids = (props) => {
    const { onSelect } = props;
    const dispatch = useAppDispatch();
    const { color: currentColor, size: currentSize, sizes, colors, } = useConnect(state => {
        const projectState = getProjectState(state);
        return {
            color: projectState.color,
            size: projectState.size,
            sizes: state.editor.sizes,
            colors: state.editor.colors,
        };
    });
    const onColorSelect = React.useCallback((color) => {
        dispatch(ProjectActions.setProperty({ property: 'color', value: color }));
        call(onSelect);
    }, [onSelect, dispatch]);
    const onSizeSelect = React.useCallback((size) => {
        dispatch(ProjectActions.setProperty({ property: 'size', value: size }));
        call(onSelect);
    }, [onSelect, dispatch]);
    return (React.createElement(Flex, { UNSAFE_className: "tool-picker", position: "absolute", bottom: "105%", left: -10, direction: "column", alignItems: "start", gap: "size-100" },
        React.createElement(View, { padding: "size-50", backgroundColor: "gray-200", borderColor: "gray-400", borderWidth: "thin" },
            React.createElement(ColorsGrid, { colsCount: 2, colors: colors, onSelect: onColorSelect })),
        React.createElement(View, { padding: "size-50", backgroundColor: "gray-200", borderColor: "gray-400", borderWidth: "thin" },
            React.createElement(SizesGrid, { color: currentColor, size: currentSize, sizes: sizes, onSelect: onSizeSelect }))));
};
export const StylePicker = () => {
    const { color: currentColor, size: currentSize, sizes, } = useConnect(state => {
        const projectState = getProjectState(state);
        return {
            color: projectState.color,
            size: projectState.size,
            sizes: state.editor.sizes,
        };
    });
    const [open, setOpen] = useState(false);
    const sizeRange = getMarkerSizeRange(sizes);
    return (React.createElement("div", { style: { position: 'relative' } },
        open && React.createElement(SizeColorGrids, { onSelect: () => setOpen(false) }),
        React.createElement(ActionButton, { onPress: () => setOpen(!open) },
            React.createElement(SizeIcon, { size: currentSize, color: currentColor, sizeRange: sizeRange, drawBackground: false }))));
};
